import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-meta-table-views',
  templateUrl: './meta-table-views.component.html',
  styleUrls: ['./meta-table-views.component.css']
})
export class MetaTableViewsComponent implements OnInit {
    metaTableKeyno;

    public itemsListMetaTableViews: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.metaTableKeyno = this.stateService.getStateParams()['metatable_keyno'];
    }

    private async loadMetaTableViews() {
        if (!!this.metaTableKeyno) {
            this.itemsListMetaTableViews = await this.datatask.Post(2428, { metatable_keyno: this.metaTableKeyno });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'metatableview':
                this.stateService?.go('metatableview', {
                    metatable_keyno: this.metaTableKeyno,
                    metatableview_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMetaTableViews();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTableViews', {
//        templateUrl: 'views/components/views/metaTableViews/metaTableViews.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'metaTableViewsService', function ($stateParams, stateService, metaTableViewsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;

//            vm.model = {
//                itemsListMetaTableViews: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMetaTableViews() {
//                vm.model.itemsListMetaTableViews = await metaTableViewsService.listMetaTableViews({ metatable_keyno: metaTableKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'metatableview':
//                        go({
//                            metatable_keyno: metaTableKeyno,
//                            metatableview_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMetaTableViews();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
